











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.User.CreateUserCommand')
    
    export class CreateUserCommand {
        constructor( firstName: string, lastName: string, email: string, password: string ) {
            
                this.firstName = firstName;
            
                this.lastName = lastName;
            
                this.email = email;
            
                this.password = password;
            
        }

        
            public firstName: string;
        
            public lastName: string;
        
            public email: string;
        
            public password: string;
        
    }

    export interface ICreateUserCommand {
        
            firstName: string;
        
            lastName: string;
        
            email: string;
        
            password: string;
        
    }

    export async function createUser( command: CreateUserCommand ): Promise<CommandResult<void>>
    export async function createUser( { firstName, lastName, email, password }: ICreateUserCommand ): Promise<CommandResult<void>>
    export async function createUser( model: any ): Promise<CommandResult<void>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<void>;

        if(model instanceof CreateUserCommand) {
            result = await endpoint.send<CommandResult<void>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<void>>( new CreateUserCommand( model['firstName'], model['lastName'], model['email'], model['password'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace CreateUserCommand.ExtraneousTypes {
        

        
    }

